<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

function onBack() {
  if (window.history.state.back)
    history.back()
  else
    router.replace('/')
}
</script>

<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <van-icon name="warn-o" size="3em" />
      <div class="not-found-text">Not found</div>
      <div class="mt-10">
        <button van-haptics-feedback class="btn" @click="onBack">
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.not-found-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  color: #9ca3af;
}

.not-found-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.not-found-text {
  font-size: 18px;
  font-weight: 500;
  margin-top: 10px;
}

.btn {
  background: #40b665;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn:hover {
  background: #1ecb7b;
}

.btn:active {
  background: #1a6b4f;
}
</style>

<route lang="json5">
{
  name: '404',
  meta: {
    title: '404',
    i18n: 'menus.404Demo'
  },
}
</route>
